import declare from "dojo/_base/declare";
import BaseRenderer from "./BaseRendererForDateTime";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import { getDefaultDateTimeFormat, convertCentricToStandardLocale, FORMAT_TIME } from "csi/utility/dateUtility";

const TimePatternRenderer = declare(BaseRenderer, {

	dateTimeSelector: "time",
	invalidDateTimeResource: "InvalidTimeFormatException",

	/**
	 * @override
	 * If entered value is empty then return the default time pattern for the current locale
	 */
	fromHtmlDynamic(ctx: Context, h: Heading, editNode: HTMLElement): string {
		const value = this.inherited<string>(arguments);
		if (!value) {
			return getDefaultDateTimeFormat(convertCentricToStandardLocale(ctx.getParent().$Name), FORMAT_TIME);
		}
		return value;
	},
});

export = TimePatternRenderer;
